// Centralized plan catalog for GetSpark.
// Used by /app/plans (pricing page), /app/billing, useSubscription hook,
// UpgradeModal, PlanBadge, limits enforcement (BusinessCreate, Feed).
//
// All amounts in CENTS (BRL). Adapter-ready for future currencies.

export const CURRENCY = 'BRL';

export const PLANS = {
  // ====== ENTREPRENEUR ======
  entrepreneur_free: {
    id: 'entrepreneur_free',
    persona: 'entrepreneur',
    name: 'Empreendedor',
    tier: 'free',
    price_cents: 0,
    price_label: 'Grátis',
    period_label: 'sempre',
    headline: 'Comece sem gastar nada.',
    cta: 'Plano atual',
    badge: null,
    accent: 'blue',
    features: [
      '1 negócio ativo',
      'Receber Sparks ilimitadas',
      'Chat liberado',
      'Perfil público',
    ],
    limits: { activeBusinesses: 1 },
  },
  entrepreneur_pro: {
    id: 'entrepreneur_pro',
    persona: 'entrepreneur',
    name: 'Empreendedor PRO',
    tier: 'pro',
    price_cents: 2990,
    price_label: 'R$ 29,90',
    period_label: 'por mês',
    headline: 'Para quem quer ser visto e crescer.',
    cta: 'Fazer upgrade',
    badge: 'PRO',
    accent: 'blue',
    features: [
      'Negócios ilimitados',
      'Perfil verificado',
      'Destaque no Feed',
      'Estatísticas avançadas',
      'Badge PRO',
      'Destaque nas pesquisas',
    ],
    limits: { activeBusinesses: Infinity },
  },

  // ====== INVESTOR ======
  investor_free: {
    id: 'investor_free',
    persona: 'investor',
    name: 'Investidor',
    tier: 'free',
    price_cents: 0,
    price_label: 'Grátis',
    period_label: 'sempre',
    headline: 'Conheça histórias inspiradoras.',
    cta: 'Plano atual',
    badge: null,
    accent: 'gold',
    features: [
      'Visualizar negócios',
      'Curtir',
      'Salvar',
      'Até 3 Sparks por mês',
    ],
    limits: { monthlySparks: 3 },
  },
  investor_pro: {
    id: 'investor_pro',
    persona: 'investor',
    name: 'Investidor PRO',
    tier: 'pro',
    price_cents: 4990,
    price_label: 'R$ 49,90',
    period_label: 'por mês',
    headline: 'Mais Sparks, mais oportunidades.',
    cta: 'Fazer upgrade',
    badge: 'PRO',
    accent: 'gold',
    features: [
      'Sparks ilimitadas',
      'Perfil verificado',
      'Filtros avançados',
      'Histórico completo',
      'Recomendações prioritárias',
      'Badge PRO',
    ],
    limits: { monthlySparks: Infinity },
  },
  investor_elite: {
    id: 'investor_elite',
    persona: 'investor',
    name: 'Investidor ELITE',
    tier: 'elite',
    price_cents: 9990,
    price_label: 'R$ 99,90',
    period_label: 'por mês',
    headline: 'Acesso prioritário a oportunidades.',
    cta: 'Fazer upgrade',
    badge: 'ELITE',
    accent: 'gradient',
    features: [
      'Tudo do PRO',
      'Acesso antecipado às oportunidades',
      'Destaque Premium',
      'Badge ELITE',
      'Suporte prioritário',
    ],
    limits: { monthlySparks: Infinity },
  },
};

// Helpers
export const getPlan = (id) => PLANS[id] || PLANS.entrepreneur_free;

export const getPlansForPersona = (persona) =>
  Object.values(PLANS).filter((p) => p.persona === persona);

export const formatBRL = (cents) => {
  if (cents === 0) return 'Grátis';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(cents / 100);
};

// Format funding target (in raw numbers, e.g. 50000 -> R$ 50 mil)
export const formatFundingTarget = (raw) => {
  const n = Number(raw) || 0;
  if (n === 0) return 'A definir';
  if (n >= 1000000) {
    const millions = n / 1000000;
    return `R$ ${millions % 1 === 0 ? millions.toFixed(0) : millions.toFixed(1)} ${millions === 1 ? 'milhão' : 'milhões'}`;
  }
  if (n >= 1000) return `R$ ${Math.round(n / 1000)} mil`;
  return `R$ ${n.toLocaleString('pt-BR')}`;
};
